import axios from "../interceptors/axios";

const PUBLIC_REQUEST_CONFIG = Object.freeze({ skipUserToken: true });

export class PasswordServer {
    forgot = (data) => axios.post("/api/forgot-password", data, PUBLIC_REQUEST_CONFIG);

    reset = (data) => axios.post("/api/reset-password", data, PUBLIC_REQUEST_CONFIG);
}
